/**
 * Fonction utilitaire pour rogner une image
 * Basée sur react-easy-crop
 */

export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

export const getCroppedImg = async (imageSrc, pixelCrop) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('Impossible d\'obtenir le contexte 2D du canvas');
  }

  // Définir la taille du canvas selon la zone rognée
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Dessiner l'image rognée sur le canvas
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // Retourner l'image rognée en data URL (pas blob URL pour éviter les problèmes CSP)
  return canvas.toDataURL('image/jpeg', 0.95);
};
